import { defineComponent as _defineComponent } from 'vue'
import Wizard from '@/components/wizard/Wizard.vue';
import NotificationRecipientSelectionWizardStep from './NotificationRecipientSelectionWizardStep.vue';
import NotificationContentWizardStep from './NotificationContentWizardStep.vue';
import { useI18n } from '@/composables/i18n';
import { toastService } from '@/library-services/toast.service';
import { notificationsService } from '@/services/notifications.service';
import { reactive, ref } from 'vue';
import { FormValues } from './model';
import { AlertAction } from '@/models/enums/AlertsEnums';
import { dialogService } from '@/library-services/dialog.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminNotificationWizard',
  emits: ['close'],
  setup(__props, { emit }) {



const isSubsidiaryNotification = ref(false);
const formValues = reactive<FormValues>({
  recipients: [],
  message: '',
  sendEmailToAllUsers: false,
  alertAction: AlertAction.None,
  emailSubject: '',
});

const { t } = useI18n();

async function sendSubsidiaryNotification() {
  await notificationsService.createCustomNotification({
    message: formValues.message,
    subject: formValues.emailSubject,
    tenantIds: [],
    subsidiaryIds: formValues.recipients.map((r) => r.id),
    sendToAll: false,
    action: formValues.alertAction,
  });
}

async function sendCustomerNotification() {
  await notificationsService.createCustomNotification({
    message: formValues.message,
    subject: formValues.emailSubject,
    tenantIds: formValues.recipients.map((r) => r.id),
    subsidiaryIds: [],
    sendToAll: formValues.sendEmailToAllUsers,
    action: formValues.alertAction,
  });
}

async function confirmSubmit() {
  dialogService.confirmWithPromise({
    title: t('dialog.confirm_title').toString(),
    message: getConfirmationMessage(),
    confirmText: t('dialog.confirm_send').toString(),
    cancelText: t('dialog.confirm_cancel').toString(),
    type: 'is-primary',
    onConfirm: async () => await onSubmit(),
  });
}

async function onSubmit() {
  try {
    if (isSubsidiaryNotification.value) {
      await sendSubsidiaryNotification();
    } else {
      await sendCustomerNotification();
    }
    toastService.success(
      t('alert_notification_wizard.notification_sent').toString(),
    );
  } finally {
    emit('close');
  }
}

function onStepInput(value: FormValues) {
  Object.assign(formValues, value);
}

function getConfirmationMessage() {
  const recipients = formValues.recipients.map((x) => x.name).join(', ');
  if (isSubsidiaryNotification.value) {
    return t('alert_notification_wizard.send_confirm_subsidiaries', {
      recipients,
    }).toString();
  }
  return t('alert_notification_wizard.send_confirm_customers', {
    recipients,
  }).toString();
}

return { __sfc: true,emit, isSubsidiaryNotification, formValues, t, sendSubsidiaryNotification, sendCustomerNotification, confirmSubmit, onSubmit, onStepInput, getConfirmationMessage, Wizard, NotificationRecipientSelectionWizardStep, NotificationContentWizardStep }
}

})